import styled, { css } from 'styled-components';
import {} from './index.js';
import React from 'react';
import { getTypographyStyles, SEM_TYPOGRAPHY_FEEDBACK_COPY, SEM_TYPOGRAPHY_FEEDBACK_HEADLINE, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_50, getMargins, SYS_BORDER_RADIUS_MD, SYS_BORDER_RADIUS_SM, SYS_SPACE_FIXED_150, SYS_BORDER_WIDTH_100, SYS_SPACE_FIXED_250, SYS_SPACE_FIXED_25 } from '@oneaudi/unified-web-alpha-common';
import { TextLink } from '../text-link/index.js';
import { Icon } from '../icon/index.js';
import { Badge } from '../badge/index.js';
import { IconButton } from '../icon-button/index.js';
export const StyledContainer = styled.div `
  display: flex;
  padding: ${SYS_SPACE_FIXED_200};
  flex-direction: column;
  align-items: flex-start;
  background: ${(props) => props.theme.sys.gradient.elevation.level1.fill};
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.default};
  margin: ${(props) => getMargins(props.margin)};
  border-radius: ${SYS_BORDER_RADIUS_MD};
  ${(props) => css `
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.sys.color.elevation.level1.stroke};
  `}
`;
export const StyledTextLink = styled(TextLink) `
  margin-top: ${SYS_SPACE_FIXED_250};
  align-self: start;
`;
export const StyledTitle = styled(({ ...props }) => {
    const HtmlTag = props.tag;
    return React.createElement(HtmlTag, { ...props }, props.text);
}) `
  margin: 0;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_HEADLINE)}
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  margin: ${SYS_SPACE_FIXED_25} ${SYS_SPACE_FIXED_150} 0 0;
  color: ${(props) => props.name === 'info-circle'
    ? props.theme.sem.color.feedback.foreground.icon.warning
    : props.name === 'select-circle'
        ? props.theme.sem.color.feedback.foreground.icon.success
        : props.name === 'break'
            ? props.theme.sem.color.feedback.foreground.icon.default
            : props.theme.sem.color.feedback.foreground.icon.error};
`;
export const StyledTextWrap = styled.div ``;
export const StyledUpperContainer = styled.div `
  display: flex;
  align-items: flex-start;
  width: 100%;

  ${StyledTextWrap} {
    padding: ${SYS_SPACE_FIXED_50} ${SYS_SPACE_FIXED_100} 0 0;
  }
`;
export const StyledBadge = styled(Badge) `
  margin: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_100} 0 0;
`;
export const StyledIconButton = styled(IconButton) `
  margin-left: auto;
`;
export const StyledCopy = styled.div `
  &:not(:first-child) {
    margin-top: ${SYS_SPACE_FIXED_50};
  }
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_COPY)}
`;
export const StyledImage = styled.img `
  aspect-ratio: '16/9';
  width: 100%;
  margin-top: ${SYS_SPACE_FIXED_150};
  border-radius: ${SYS_BORDER_RADIUS_SM};
`;
//# sourceMappingURL=index.styles.js.map